// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {
  getFirestore,
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  deleteDoc,
  setDoc,
} from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBweavqbTJVA8FtFz1TZ91d6riYrZra2mo",
  authDomain: "witsrhi-journeytool-myprep.firebaseapp.com",
  projectId: "witsrhi-journeytool-myprep",
  storageBucket: "witsrhi-journeytool-myprep.appspot.com",
  messagingSenderId: "324990023383",
  appId: "1:324990023383:web:78236914c7e64204e16292",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth = getAuth();
const db = getFirestore();
export {
  app,
  auth,
  signInWithEmailAndPassword,
  signOut,
  db,
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  deleteDoc,
  setDoc,
};
